import { createTheme } from '@mantine/core';

export const theme = createTheme({
  /** Put your mantine theme override here */
});

// Default QR code color (corporate color fallback)
export const DEFAULT_QR_CODE_COLOR = '#5D7723';

/** Muted olive green for confirm/success actions (aligned with brand default). */
export const BRAND_CONFIRM_GREEN = {
  light: '#7a9638',
  base: DEFAULT_QR_CODE_COLOR,
  dark: '#4d631f',
  deep: '#3f5219',
} as const;
